// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgDesktopOnUnique24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				viewBox="0 0 45 45"
				fill="none"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					d="M35.4039 13.5718H10.2039C9.54116 13.5718 9.00391 14.109 9.00391 14.7718V26.1718C9.00391 26.8345 9.54116 27.3718 10.2039 27.3718H35.4039C36.0666 27.3718 36.6039 26.8345 36.6039 26.1718V14.7718C36.6039 14.109 36.0666 13.5718 35.4039 13.5718Z"
					fill="#2E2F32"
					fillOpacity={0.12}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M36.0037 11.8253H9.60371C8.27823 11.8253 7.20371 12.8998 7.20371 14.2253V26.8253C7.20371 28.1508 8.27823 29.2253 9.60371 29.2253H22.8015H22.8037H22.8059H36.0037C37.3292 29.2253 38.4037 28.1508 38.4037 26.8253V14.2253C38.4037 12.8998 37.3292 11.8253 36.0037 11.8253ZM24.0037 31.6253H36.0037C38.6547 31.6253 40.8037 29.4763 40.8037 26.8253V14.2253C40.8037 11.5743 38.6547 9.42529 36.0037 9.42529H9.60371C6.95274 9.42529 4.80371 11.5743 4.80371 14.2253V26.8253C4.80371 29.4763 6.95274 31.6253 9.60371 31.6253H21.6037V34.3253H14.4037C13.741 34.3253 13.2037 34.8626 13.2037 35.5253C13.2037 36.188 13.741 36.7253 14.4037 36.7253H22.8037H31.2037C31.8664 36.7253 32.4037 36.188 32.4037 35.5253C32.4037 34.8626 31.8664 34.3253 31.2037 34.3253H24.0037V31.6253Z"
					fill="#2E2F32"
				/>
			</Svg>
		);
	}
);
SvgDesktopOnUnique24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgDesktopOnUnique24;
